import Swal from 'sweetalert2/dist/sweetalert2.js'

export const swalWithButtonsW = Swal.mixin({
  customClass: {
    confirmButton: 'button is-link has-background-w-primary'
  },
  buttonsStyling: false
})
